import { axios } from '@Root/API'

export const get = (studyProgrammeId, moduleInstanceId) => {
	return axios.get(`course-session/${studyProgrammeId}/module-instances/${moduleInstanceId}`)
}
